import {
    FETCH_MIXED_GRAPH_REQUEST,
    FETCH_MIXED_GRAPH_SUCCESS,
    FETCH_MIXED_GRAPH_ERROR,
    FETCH_MULTI_GRAPH_REQUEST,
    FETCH_MULTI_GRAPH_SUCCESS,
    FETCH_MULTI_GRAPH_ERROR,
    FETCH_SINGLE_REQUEST,
    FETCH_SINGLE_SUCCESS,
    FETCH_SINGLE_ERROR,
    FETCH_DASHBOARD_SUMMARY_REQUEST,
    FETCH_DASHBOARD_SUMMARY_SUCCESS,
    FETCH_DASHBOARD_SUMMARY_ERROR,
    SHOW_DASHBOARD_LOADER,
    HIDE_DASHBOARD_LOADER,
    RESET_DASHBOARD_REQUEST,
    FETCH_MULTI_ENTITY_HIERARCHY_REQUEST,
    FETCH_MULTI_ENTITY_HIERARCHY_SUCCESS,
    FETCH_MULTI_ENTITY_HIERARCHY_ERROR,
} from './dashboard.constants';

export const fetchMixedGraphRequest = payload => ({
    type: FETCH_MIXED_GRAPH_REQUEST,
    payload,
});

export const fetchMixedGraphSuccess = payload => ({
    type: FETCH_MIXED_GRAPH_SUCCESS,
    payload,
});

export const fetchMixedGraphError = payload => ({
    type: FETCH_MIXED_GRAPH_ERROR,
    payload,
});

export const fetchMultiGraphRequest = payload => ({
    type: FETCH_MULTI_GRAPH_REQUEST,
    payload,
});

export const fetchMultiGraphSuccess = payload => ({
    type: FETCH_MULTI_GRAPH_SUCCESS,
    payload,
});

export const fetchMultiGraphError = payload => ({
    type: FETCH_MULTI_GRAPH_ERROR,
    payload,
});

export const fetchSingleGraphRequest = payload => ({
    type: FETCH_SINGLE_REQUEST,
    payload,
});

export const fetchSingleGraphSuccess = payload => ({
    type: FETCH_SINGLE_SUCCESS,
    payload,
});

export const fetchSingleGraphError = payload => ({
    type: FETCH_SINGLE_ERROR,
    payload,
});

export const fetchDashboardSummaryRequest = payload => ({
    type: FETCH_DASHBOARD_SUMMARY_REQUEST,
    payload,
});

export const fetchDashboardSummarySuccess = payload => ({
    type: FETCH_DASHBOARD_SUMMARY_SUCCESS,
    payload,
});

export const fetchDashboardSummaryError = payload => ({
    type: FETCH_DASHBOARD_SUMMARY_ERROR,
    payload,
});

export const resetDashboardRequest = () => ({
    type: RESET_DASHBOARD_REQUEST,
});

export const fetchMultiEntityHierarchyRequest = (
    payload,
    level,
    entityType,
    onSuccess
) => ({
    type: FETCH_MULTI_ENTITY_HIERARCHY_REQUEST,
    payload,
    level,
    entityType,
    onSuccess,
});

export const fetchMultiEntityHierarchySuccess = (payload, entityType) => ({
    type: FETCH_MULTI_ENTITY_HIERARCHY_SUCCESS,
    payload,
    entityType,
});

export const fetchMultiEntityHierarchyError = payload => ({
    type: FETCH_MULTI_ENTITY_HIERARCHY_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_DASHBOARD_LOADER });

export const hideLoader = () => ({ type: HIDE_DASHBOARD_LOADER });
